import React, { useMemo } from 'react'
import {
  CustomDropdownItemOption,
  DropDownItemOptionComponentProps,
  SelectDropdown,
  SelectOption,
} from '../../../../../../../components/SelectDropdown/SelectDropdown'
import classNames from 'classnames'

export interface ResultOption {
  className?: string
  selectOption: SelectOption
  icon: string
  handleSelected: (option: SelectOption) => void | Promise<void>
}

export interface ResultOptionsButtonProps {
  resultOptions: ResultOption[]
}

export const ResultOptionsButton: React.FC<ResultOptionsButtonProps> = ({ resultOptions }) => {
  const options = useMemo(() => resultOptions.map(({ selectOption }) => selectOption), [resultOptions])

  const handleOptionSelected = async (option: SelectOption) => {
    const { id: resultOptionId } = option
    const resultOption = resultOptions.find((resultOption) => resultOption.selectOption.id === resultOptionId)
    if (!resultOption) {
      return
    }
    const { handleSelected } = resultOption
    await handleSelected(option)
  }

  const ResultOptionsDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = ({ optionId, optionLabel, disabled, onClick }) => {
    const resultOption = resultOptions.find((resultOption) => resultOption.selectOption.id === optionId)
    if (!resultOption) {
      return null
    }
    const { icon, className } = resultOption

    return (
      <CustomDropdownItemOption
        role='button'
        onClick={onClick}
        className={classNames('d-flex gap-2 align-items-center', className, { 'dropdown-item-disabled': disabled })}
      >
        <i className={`bi ${icon}`} />
        {optionLabel}
      </CustomDropdownItemOption>
    )
  }

  return (
    <div className='d-flex align-items-start result-options-container mb-3 position-relative'>
      <div className='position-absolute'>
        <SelectDropdown
          className='p-1 justify-content-center result-options-select-dropdown'
          options={options}
          icon='bi-grip-vertical'
          iconOnly
          hideArrows
          onOptionSelected={handleOptionSelected}
          DropDownItemOptionComponent={ResultOptionsDropdownItemOption}
          scrollWhenOpened
        />
      </div>
    </div>
  )
}
